import { render, staticRenderFns } from "./sSearchFarm.vue?vue&type=template&id=b9f2721c"
import script from "./sSearchFarm.vue?vue&type=script&lang=js"
export * from "./sSearchFarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports